import {observer} from 'mobx-react';
import React from 'react';
import {InsigniaCustomization} from '../../../i';
import s from '../../../s';
import {getTitle} from '../insignia';
import {Portal} from '../../../../util';
import {OwnedPopoverScope} from '../../shared/owned-popovers/use-owned-popovers';
import {useOptionList} from '../../option-list/option-list';

type InsigniaListProps = {
    collapsed: boolean;
    collapsedNumber: number;
    items: InsigniaCustomization[];
    save: (id: number) => void;
    isModal?: boolean;
};

export const InsigniaList = observer((props: InsigniaListProps) => {
    const {isModal, collapsed, collapsedNumber, save, items} = props;
    const list = items.slice(0, collapsedNumber);
    const selectedId = s.preferredInsigniaId(s.ps.insignia_id);
    const optionList = useOptionList(
        list.map(m => ({domId: `ins-${m.id}`, value: m.id})),
        selectedId,
        save,
    );

    return (
        <OwnedPopoverScope
            className="ins-prod"
            style={{justifyContent: isModal ? 'space-around' : ''}}
            role="listbox"
            aria-label="Select Insignia"
            syncKey={`${s.ui.color_mat1}:${list.map(m => m.id).join(',')}`}
            onKeyDown={optionList.onKeyDown}
        >
            {list.map((m: InsigniaCustomization, i: number) => {
                const opt = optionList.option(m.id);
                return (
                    <div
                        data-bs-toggle={window.innerWidth > 1200 ? 'popover' : ''}
                        data-bs-placement="top"
                        data-bs-html="true"
                        data-bs-trigger="hover focus"
                        data-bs-content={`<div class="prod-img-zoom" style="background-color:#${s.ui.color_mat1}"><div style="background-color:#${s.ui.color_mat1}"><img loading="lazy" src="https://${Portal?.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_220.png" alt="" /></div></div>`}
                        title={getTitle(m.title, m.ins_color)}
                        role="option"
                        id={opt.id}
                        key={m.id}
                        data-id={m.id}
                        aria-label={`Select ${getTitle(m.title, m.ins_color)} insignia`}
                        aria-selected={opt.ariaSelected}
                        className={`cust-entity${selectedId === m.id ? ' active' : ''}${!collapsed ? ' active-bold' : ''}`}
                        onClick={opt.onActivate}
                        onKeyDown={opt.onKeyDown}
                        data-img={`https://${Portal?.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_220.png`}
                        tabIndex={opt.tabIndex}
                    >
                        <div
                            data-id={m.id}
                            className="ins"
                            style={{backgroundColor: `#${s.ui.color_mat1}`}}
                        >
                            <img
                                data-id={m.id}
                                loading="lazy"
                                src={`https://${Portal?.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_90.png`}
                                width="90"
                                alt={getTitle(m.title, m.ins_color)}
                            />
                        </div>
                        <div
                            className="title"
                            data-id={m.id}
                        >
                            {getTitle(m.title, m.ins_color)}
                        </div>
                    </div>
                );
            })}
        </OwnedPopoverScope>
    );
});
